import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import TrainingRequestsList from "../Components/TrainingRequestsList";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import "./TrainingRequests.css";

function TrainingRequests() {
  const [isLoading, setIsLoading] = useState(true);
  const [requests, setRequests] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/${state.userId}`,
        data: { language: state.language, organization: state.organization },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setRequests(response.data.requests);
      setIsLoading(false);
    }
    fetch();
  }, [state.userId, state.language, state.token, state.organization]);

  let breadcrumbs = [
    {
      title: "Planes desarrollo",
      path: "/trainings/training-status",
    },
  ];

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Breadcrumbs data={breadcrumbs} />
        </Row>
        <Row className="align-items-center">
          <Col lg={9} className="trainings">
            <h2>{t("Capacitaciones.SolicitudesCapacitacion.Titulo")}</h2>
          </Col>
          <Col lg={3} className="right trainings-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/trainings/requests/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Capacitaciones.SolicitudesCapacitacion.NuevaSolicitud")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {requests.length === 0 ? (
            <Col className="empty-trainings center">
              <h5>
                {t("Capacitaciones.SolicitudesCapacitacion.SinSolicitudes")}
              </h5>
            </Col>
          ) : (
            <TrainingRequestsList
              requests={requests}
              language={state.language}
              role={state.role}
              userId={state.userId}
            />
          )}
        </Row>
      </Container>
    );
  }
}

export default TrainingRequests;
